import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { SolanaWalletProvider } from './WalletProvider';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SolanaWalletProvider>
      <App />
    </SolanaWalletProvider>
  </React.StrictMode>
);

reportWebVitals();
